/** Лёгкая шина событий клиента: успешные команды (для обновления счётчиков шелла и т.п.). */
type CommandListener = (operation: string) => void;
const listeners = new Set<CommandListener>();
export function onCommandDone(fn: CommandListener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
export function emitCommandDone(operation: string): void {
  listeners.forEach((fn) => {
    try {
      fn(operation);
    } catch {
      /* слушатель не должен ломать команду */
    }
  });
}
